import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { formFormatterRegex } from '../../../resources/formFormatterRegex';

export const ZipCode = () => {
  const { modelPrefix, onBlur } = usePropsContext();
  const { allowOnlyNumeric } = formFormatterRegex;

  return (
    <TextInput
      data-testid="zipcode"
      label="Zip code"
      model={`${modelPrefix}.zipCode`}
      maxLength={5}
      formatter={value => {
        return value.replace(allowOnlyNumeric, '');
      }}
      validators={{
        required: 'Please enter a valid zip code (XXXXX)',
        minLength: {
          value: 5,
          message: 'At least a 5 digit zip code is required',
        },
      }}
      width="50%"
      onBlur={() => onBlur(`${modelPrefix}.zipCode`)}
    />
  );
};
